export default "__VITE_ASSET__945c5e66__"